import { useEffect, useState } from "react"

const getYoutubeThumbnailFromEmbed = (embedUrl: string) => {
  // /embed/ 뒤 11자 추출
  const match = embedUrl.match(/embed\/([\w-]{11})/)
  return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : null
}

interface Props {
  embedUrl: string
  isShown?: boolean
}

const YoutubeVideo = ({ embedUrl, isShown }: Props) => {
  const [localActive, setLocalActive] = useState(false)

  useEffect(() => {
    if (!isShown) setLocalActive(false)
  }, [isShown])

  const isActive = !!isShown && localActive

  const thumbnailUrl = getYoutubeThumbnailFromEmbed(embedUrl)

  if (!isActive) {
    return (
      <button
        type="button"
        className="flex relative justify-center items-center w-full bg-black aspect-video group"
        onClick={() => setLocalActive(true)}
        style={{ cursor: "pointer" }}
      >
        {thumbnailUrl ? (
          <>
            <img
              src={thumbnailUrl}
              alt="YouTube Thumbnail"
              className="object-cover absolute inset-0 w-full h-full transition-opacity group-hover:opacity-80"
            />
            <span className="absolute p-4 text-white rounded-full bg-black/60">
              <svg
                width="48"
                height="48"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </span>
          </>
        ) : (
          <div className="z-10 text-center text-white">
            <p>Loading video...</p>
          </div>
        )}
      </button>
    )
  }

  return (
    <div
      className="relative w-full aspect-video"
      style={{ touchAction: "pan-y" }}
    >
      <iframe
        className="w-full h-full"
        src={embedUrl + (embedUrl.includes("?") ? "&" : "?") + "autoplay=1"}
        title="YouTube video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ pointerEvents: "auto" }}
      ></iframe>
    </div>
  )
}

export default YoutubeVideo
